"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mobileJobAttachmentErrorCodeV1Schema = exports.mobileJobAttachmentResponseV1Schema = exports.mobileJobAttachmentListResponseV1Schema = exports.mobileInitializeJobAttachmentResponseV1Schema = exports.mobileCompleteJobAttachmentRequestV1Schema = exports.mobileInitializeJobAttachmentRequestV1Schema = exports.mobileJobAttachmentV1Schema = exports.mobileJobAttachmentPolicyV1Schema = exports.mobileJobAttachmentOwnerV1Schema = exports.mobileJobAttachmentActionV1Schema = exports.MOBILE_JOB_ATTACHMENT_CONTRACT_VERSION = void 0;
const zod_1 = require("zod");
const job_attachment_1 = require("./job-attachment");
const job_1 = require("./job");
exports.MOBILE_JOB_ATTACHMENT_CONTRACT_VERSION = 1;
exports.mobileJobAttachmentActionV1Schema = zod_1.z.enum([
    "VIEW",
    "RETRY",
    "ARCHIVE",
]);
exports.mobileJobAttachmentOwnerV1Schema = zod_1.z.object({
    membershipId: zod_1.z.string().uuid(),
    isCurrentActor: zod_1.z.boolean(),
});
exports.mobileJobAttachmentPolicyV1Schema = zod_1.z.object({
    maxFileSizeBytes: zod_1.z.number().int().positive(),
    allowedMimeTypes: zod_1.z.array(zod_1.z.string().min(3)).min(1),
    photoMimeTypes: zod_1.z.array(zod_1.z.string().min(3)).min(1),
});
exports.mobileJobAttachmentV1Schema = zod_1.z.object({
    id: job_attachment_1.jobAttachmentIdSchema,
    jobId: job_1.jobIdSchema,
    originalFileName: zod_1.z.string().min(1),
    mimeType: zod_1.z.string().min(3),
    fileSizeBytes: zod_1.z.number().int().positive(),
    checksumSha256: job_attachment_1.jobAttachmentChecksumSchema,
    kind: job_attachment_1.jobAttachmentKindSchema,
    uploadStatus: job_attachment_1.jobAttachmentUploadStatusSchema,
    lifecycle: job_attachment_1.jobAttachmentLifecycleSchema,
    failureReason: zod_1.z.string().nullable(),
    owner: exports.mobileJobAttachmentOwnerV1Schema,
    availableActions: zod_1.z.array(exports.mobileJobAttachmentActionV1Schema),
    downloadPath: zod_1.z.string().min(1).nullable(),
    createdAt: zod_1.z.string().datetime(),
    updatedAt: zod_1.z.string().datetime(),
    readyAt: zod_1.z.string().datetime().nullable(),
    archivedAt: zod_1.z.string().datetime().nullable(),
});
exports.mobileInitializeJobAttachmentRequestV1Schema = job_attachment_1.initializeJobAttachmentRequestSchema.extend({
    clientRequestId: zod_1.z.string().uuid(),
});
exports.mobileCompleteJobAttachmentRequestV1Schema = job_attachment_1.completeJobAttachmentRequestSchema;
exports.mobileInitializeJobAttachmentResponseV1Schema = zod_1.z.object({
    contractVersion: zod_1.z.literal(exports.MOBILE_JOB_ATTACHMENT_CONTRACT_VERSION),
    attachment: exports.mobileJobAttachmentV1Schema,
    upload: job_attachment_1.jobAttachmentUploadTargetSchema.nullable(),
});
exports.mobileJobAttachmentListResponseV1Schema = zod_1.z.object({
    contractVersion: zod_1.z.literal(exports.MOBILE_JOB_ATTACHMENT_CONTRACT_VERSION),
    policy: exports.mobileJobAttachmentPolicyV1Schema,
    items: zod_1.z.array(exports.mobileJobAttachmentV1Schema),
});
exports.mobileJobAttachmentResponseV1Schema = zod_1.z.object({
    contractVersion: zod_1.z.literal(exports.MOBILE_JOB_ATTACHMENT_CONTRACT_VERSION),
    attachment: exports.mobileJobAttachmentV1Schema,
});
exports.mobileJobAttachmentErrorCodeV1Schema = zod_1.z.enum([
    "ASSIGNED_WORK_NOT_FOUND",
    "JOB_ATTACHMENT_NOT_FOUND",
    "JOB_ATTACHMENT_INVALID",
    "JOB_ATTACHMENT_STATE_CONFLICT",
    "JOB_ATTACHMENT_STORAGE_UNAVAILABLE",
    "JOB_ATTACHMENT_WRITE_FORBIDDEN",
    "JOB_ATTACHMENT_IDEMPOTENCY_CONFLICT",
]);
//# sourceMappingURL=mobile-job-attachment.js.map